import { responseAuthenServiceTypes } from './types'
import * as authenServiceURL from './authenServiceURL'
import useCallApi from '../../utilities/axios'

const useAuthenService = () => {
    const callApi = useCallApi()
    const example1 = async () => {
        const { data } = await callApi.axiosGet<any>({
            url: authenServiceURL.example,
        })
        return data
    }
    const example2 = async () => {
        const { data } = await callApi.axiosGet<any>({
            url: authenServiceURL.example,
        })
        return data
    }

    const login = async (params: {}) => {
        const { data } = await callApi.axiosPost<any>({
            url: authenServiceURL.login,
            params: params,
        })
        return data
    }

    const getProfile = async (params: string, loginType?: 1 | 2) => {
        let url = authenServiceURL.getProfile
        if (loginType) {
            url = `${authenServiceURL.getProfile}/${loginType}`
        }
        const { data } = await callApi.axiosGet<responseAuthenServiceTypes.GetProfileType>({
            url: url,
            token: params,
        })
        return data
    }

    return {
        example1,
        example2,
        login,
        getProfile,
    }
}

export default useAuthenService
